import { render, staticRenderFns } from "./inline-spinner.component.vue?vue&type=template&id=34d1094b&scoped=true&lang=pug"
import script from "./inline-spinner.component.vue?vue&type=script&lang=ts"
export * from "./inline-spinner.component.vue?vue&type=script&lang=ts"
import style0 from "./inline-spinner.component.vue?vue&type=style&index=0&id=34d1094b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d1094b",
  null
  
)

export default component.exports